import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  // Check if current route is "/" or "/about"
  const isTargetPage =
    location.pathname === "/" || location.pathname === "/about";

  const data = [
    { title: t("about"), href: "about" },
    { title: t("products"), href: "category" },
    { title: t("contacts"), href: "contacts" },
  ];

  return (
    <div
      className={`${
        // ✅ Add 1000px margin only on mobile and for target pages
        isTargetPage
          ? "mt-[700px] md:mt-[20px]"
          : "mt-[20px]"
      } px-4 md:px-[20px] lg:px-[20px] xl:px-[100px] py-[20px] lg:py-[40px] flex-col flex items-center`}
    >
      <nav className="mt-7 border-t border-[#b4b1aa] py-7 w-full">
        <ul className="flex flex-col md:flex-row gap-x-20 lg:gap-x-24">
          {data.map(({ href, title }) => (
            <li className="m-2" key={title}>
              <Link to={href} onClick={handleClick}>
                <p className="text-darkBg dark:text-lightBg text-sm text-center">
                  {title}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div className="flex flex-col-reverse md:flex-row justify-between w-full">
        <div className="text-white flex text-nowrap gap-x-7 items-start md:items-center justify-between mt-10 md:mt-0">
          <Link
            to="https://www.instagram.com/bytebridges_academy?igsh=MXFwMXpjcHpwcnVoeQ=="
            target="_blank"
          >
            <p>Copyright . 2025 Byte Bridges</p>
          </Link>
        </div>
        <div className="text-[#b4b1aa] flex-col flex">
          <Link target="_blank" to={`tel:+37477083388`}>
            +34 657 91 69 82
          </Link>
           <Link target="_blank" to={`tel:+37477083388`}>
            +34 685 85 10 56
          </Link>
          <Link
            target="_blank"
            to={`mailto:comercialveselitolstyak@gmail.com`}
          >
            comercialveselitolstyak@gmail.com
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
